import { Titlebar } from '@components/Titlebar/Titlebar'
import { useContacts } from '@plug-core/state'
import { addressToChain } from '@plug-core/utils/addressMatcher'
import { Button, Field, Input } from '@ui'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Params {
  address?: string
  close: () => void
  onSave?: (newAddress: string) => void
}

const ContactForm: FC<Params> = ({ address: initialAddress, close, onSave }) => {
  const [name, setName] = useState('')

  const { t } = useTranslation(undefined, { keyPrefix: 'contactForm' })
  const { addContact } = useContacts()

  const handleSave = () => {
    const chain = initialAddress && addressToChain(initialAddress)
    const id = addContact({
      name,
      avatar: '👽',
      addresses: chain ? [{ address: initialAddress, chain }] : [],
    })

    onSave?.(id)
    close()
  }

  return (
    <div className="mb-3 flex flex-col gap-4">
      <Titlebar title={t('add')} />

      <Field>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t('name')}
          aria-label={t('name')}
          autoFocus={true}
        />
      </Field>

      <Button fullWidth onClick={handleSave} disabled={!name} variant="primary">
        {t('save')}
      </Button>
    </div>
  )
}

export default ContactForm
